(() => {
  const rootSelector = '.p-attribute-icons';
  const openClass = 'is-tooltip-open';

  function closeAll(root) {
    root.querySelectorAll(`.${openClass}`).forEach((btn) => btn.classList.remove(openClass));
  }

  document.addEventListener('click', (e) => {
    const root = e.target.closest(rootSelector);
    if (!root) return;

    const btn = e.target.closest('.p-attribute-icons__item');
    if (!btn) {
      closeAll(root);
      return;
    }

    // Toggle tooltip via class (improves touch/mobile experience)
    const isOpen = btn.classList.contains(openClass);
    closeAll(root);
    if (!isOpen) btn.classList.add(openClass);
  });

  // Close on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(rootSelector).forEach(closeAll);
  });
})();
